import Image from "next/image";
import { v4 } from "uuid";

import { imageLoader } from "@aprosoja/utils";
import { useToastFeedbackUser } from "@aprosoja/stores";
import { Button, IconButton, Text } from "@aprosoja/ui";

import { useSignUpContext } from "@/app/screens/sign-up/context/sign-up.context";
import ContentWrapper from "../components/content-wrapper";
import { PixInformations } from "@aprosoja/containers";

const PixInfo = () => {
  const { setToast } = useToastFeedbackUser();
  const { signUpReducer, setSignUpReducer } = useSignUpContext();

  return (
    <div className="flex flex-col w-full gap-size-x6">
      <ContentWrapper title="Pagamento por pix" hasSummary>
        <PixInformations
          code={signUpReducer.pixOrBankSlipInfo?.paymentCode ?? ""}
          imageBase64={signUpReducer.pixOrBankSlipInfo?.paymentImage ?? ""}
        />
      </ContentWrapper>
      <div className="flex w-full justify-end">
        <Button
          className="rounded-border-radius-small"
          onClick={() =>
            setSignUpReducer({ type: "signUpStep", signUpStepPayload: 5 })
          }
        >
          Prosseguir
        </Button>
      </div>
    </div>
  );
};

export default PixInfo;
